import FormComponent from "./components/form/form";
import LoginFormComponent from "./components/login-form/login-form";
import { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [loggedInUser, setLoggedInUser] = useState<{
    email: string;
    password: string;
  } | null>(() => {
    const savedUser = localStorage.getItem("loggedInUser");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    if (loggedInUser) {
      localStorage.setItem("loggedInUser", JSON.stringify(loggedInUser));
    } else {
      localStorage.removeItem("loggedInUser");
    }
  }, [loggedInUser]);

  return (
    <>
      {loggedInUser ? (
        <FormComponent loggedInUser={loggedInUser} />
      ) : (
        <LoginFormComponent
          onLogin={(user: { email: string; password: string }) =>
            setLoggedInUser(user)
          }
        />
      )}
    </>
  );
}

export default App;
